import { GlobalModalsContext } from '@/global-modals/GlobalModalsContext'
import * as React from 'react'

export function useGlobalModals() {
  return React.useContext(GlobalModalsContext).modalManager
}
